/* eslint-disable */
const config = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_ENV.toLowerCase() === 'production' ? 'us-east-1_bKETNr2yc' : 'us-east-1_uN4sTX0KR',
      userPoolClientId: process.env.REACT_APP_ENV.toLowerCase() === 'production' ? '265lp6g73s91i52oj70jugd03e' : '1oee82ut73p0dgjpj86jcadu0o',
      identityPoolId:
        process.env.REACT_APP_ENV.toLowerCase() === 'production' ? 'us-east-1:c5a6cf75-1cd1-481f-8a48-e99c9cf32065' : 'us-east-1:9e9b1b40-aae6-410f-b9b3-3859fafa8b6f',
      authenticationFlowType: 'USER_PASSWORD_AUTH',
      cookieStorage: {
        domain: process.env.REACT_APP_ENV.toLowerCase() === 'production' ? '.tbd.health' : '.tbdhealth.xyz',
      },
    },
  },
}

export default config
